<template>
  <div class="checked-goods">
    <h3 v-if="result.messages" class="def-header-3">{{ result.messages.title }}</h3>

    <DefSliderWrapper v-if="screenWidth >= 992">
      <Swiper
        :modules="modules"
        :slides-per-view="6"
        :space-between="4"
        :pagination="{ clickable: true }"
        navigation
      >
        <SwiperSlide v-for="item in result.items" :key="item.id">
          <a class="checked-goods__link" :href="item.detailPage">
            <DefLabels :result="item.labels" />
            <DefImg :key="item.id" :result="item.picture" />
            <GiaPhoto v-if="item.isGia" />
          </a>
        </SwiperSlide>
      </Swiper>
    </DefSliderWrapper>

    <PerfectScrollbar v-else class="checked-goods__mobile">
      <!--            <product-card-2 v-for="(item,i) in result.items" :key="i" :result="item"/>-->
      <a
        v-for="item in result.items"
        :key="item.id"
        class="checked-goods__link"
        :href="item.detailPage"
      >
        <!--        <img :key="item.id" :src="item.picture.src" :alt="item.picture.alt" />-->
        <DefImg :key="item.id" :result="item.picture" />
        <GiaPhoto v-if="item.isGia" />
      </a>
    </PerfectScrollbar>
  </div>
</template>

<script>
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import DefSliderWrapper from '@components/sliders/DefSliderWrapper.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import { screenWidth } from '@use/useDeviceInfo';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefLabels from '@components/Def/DefLabels/DefLabels.vue';

export default {
  name: 'CheckedGoods',
  components: {
    DefLabels,
    DefImg,
    GiaPhoto,
    DefSliderWrapper,
    Swiper,
    SwiperSlide,
    PerfectScrollbar,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      modules: [Navigation, Pagination],
      screenWidth,
    };
  },
};
</script>

<style lang="scss" scoped>
.checked-goods {
  margin: 24px 0;
  width: 100%;
  margin-top: 0;
  @include point-md {
    margin: 30px 0;
    margin-top: 0;
  }
  @include point-lg {
    margin: 48px 0;
  }
  &__link {
    position: relative;
    flex-shrink: 0;
    :deep(.gia-photo) {
      position: absolute;
      right: 12px;
      bottom: 12px;
    }
    :deep(.def-labels) {
      position: absolute;
      left: 12px;
      top: 12px;
    }
  }
  &__mobile {
    display: flex;
    overflow-x: auto;
    margin: 28px 0;
    padding-bottom: 20px;
    & > * {
      //width: 100%;
      &:not(:last-child) {
        margin-right: 4px;
      }
    }
    img {
      width: 176px;
      @include point-lg {
        width: auto;
      }
    }
  }
}
</style>
